import React, { useState } from "react";
import Logo from "../../assets/LogoUniteBlanc.png";

const Navbar = () => {
    const [isNavbarOpen, setIsNavbarOpen] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    return (
        <nav
            className="bg-transparent dark:border-gray-700 h-24 w-full absolute top-0 left-0 z-50">            {/* Changed 'fixed' to 'absolute' */}

            <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto px-4 py-2">
                <a href="../" className="flex items-center space-x-3 rtl:space-x-reverse">
                    <img src={Logo} className="h-44" alt="Logo Sainte Véronique" />
                </a>
                {/* Hamburger menu button */}
                <button
                    onClick={() => setIsNavbarOpen(!isNavbarOpen)}
                    type="button"
                    className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-800 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
                    aria-controls="navbar-multi-level"
                    aria-expanded={isNavbarOpen}
                >
                    <span className="sr-only">Open main menu</span>
                    <svg
                        className="w-5 h-5"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 17 14"
                    >
                        <path
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M1 1h15M1 7h15M1 13h15"
                        />
                    </svg>
                </button>
                {/* Dropdown menu */}
                <div
                    className={`${
                        isNavbarOpen ? "block" : "hidden"
                    } w-full md:block md:w-auto`}
                    id="navbar-multi-level"
                >
                    <ul className="flex flex-col md:flex-row font-medium bg-white md:bg-transparent rounded-lg border border-gray-200 md:border-0 p-4 md:p-0 md:space-x-8">
                        <li>
                            <a
                                href="../"
                                className="block py-2 px-3 text-gray-800 md:text-white hover:text-green-600 rounded md:hover:bg-transparent md:p-0 dark:text-gray-300 dark:hover:text-green-500"
                                aria-current="page"
                            >
                                Accueil
                            </a>
                        </li>
                        <li className="relative">
                            <button
                                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                className="flex items-center justify-between w-full py-2 px-3 text-gray-900 md:text-white hover:text-green-600 md:hover:bg-transparent md:p-0 dark:text-gray-300 dark:hover:text-green-500"
                            >
                                Sections
                                <svg
                                    className="w-2.5 h-2.5 ml-2"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 10 6"
                                >
                                    <path
                                        stroke="currentColor"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="m1 1 4 4 4-4"
                                    />
                                </svg>
                            </button>
                            {isDropdownOpen && (
                                <div
                                    className="absolute z-10 mt-2 font-normal bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700">
                                    <ul className="py-2 text-sm text-gray-700 dark:text-gray-200">
                                        <li>
                                            <a
                                                href="../Staff/5"
                                                className="block px-4 py-2 hover:text-green-600 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-green-500"
                                            >
                                                Nutons
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="../Staff/3"
                                                className="block px-4 py-2 hover:text-green-600 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-green-500"
                                            >
                                                Lutins
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="../Staff/4"
                                                className="block px-4 py-2 hover:text-green-600 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-green-500"
                                            >
                                                Louveteaux
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="../Staff/2"
                                                className="block px-4 py-2 hover:text-green-600 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-green-500"
                                            >
                                                Guides
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="../Staff/1"
                                                className="block px-4 py-2 hover:text-green-600 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-green-500"
                                            >
                                                Scouts
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="../Staff/6"
                                                className="block px-4 py-2 hover:text-green-600 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-green-500"
                                            >
                                                Clan & Staff d'unité
                                            </a>
                                        </li>

                                    </ul>
                                </div>
                            )}
                        </li>
                        <li>
                            <a
                                href="../Inscription"
                                className="block py-2 px-3 text-gray-900 md:text-white hover:text-green-600 rounded md:hover:bg-transparent md:p-0 dark:text-gray-300 dark:hover:text-green-500"
                            >
                                Nous rejoindre !
                            </a>
                        </li>
                        <li>
                            <a
                                href="/Contact"
                                className="block py-2 px-3 text-gray-900 md:text-white hover:text-green-600 rounded md:hover:bg-transparent md:p-0 dark:text-gray-300 dark:hover:text-green-500"
                            >
                                Contact
                            </a>
                        </li>
                        <li>
                            <a
                                href="/IlesDePaix"
                                className="block py-2 px-3 text-gray-900 md:text-white hover:text-green-600 rounded md:hover:bg-transparent md:p-0 dark:text-gray-300 dark:hover:text-green-500"
                            >
                                Iles de paix
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;